import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { cloneDeep } from "lodash";
import { observer } from "mobx-react-lite";
import { ICustomerProperties } from "mobx-stores/_models/customers/customer";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DetailIconButton } from "share-components/mui-wrap/button/action-button";
import { XTablePagination } from "share-components/mui-wrap/table/x-table-pagination";
export const CustomerTable = observer(() => {
  const {
    customerManagement: {
      customers,
      getCustomers,
      pagination,
      setProp,
      showIsDisabled,
    },
  } = useStores();
  const navigate = useNavigate();
  useEffect(() => {
    getCustomers({
      filter: pagination.filter,
      maxResultCount: pagination.itemsPerPage,
      skipCount: pagination.skipCount,
      sorting: "",
      isDisabled: showIsDisabled,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPageChanged = useCallback(
    (_: any, page: number) => {
      pagination.setProp("pageIndex", page - 1);
      getCustomers({
        filter: pagination.filter,
        maxResultCount: pagination.itemsPerPage,
        skipCount: pagination.skipCount,
        sorting: "",
        isDisabled: showIsDisabled,
      });
    },
    [getCustomers, pagination, showIsDisabled]
  );

  const goDetailHandler = useCallback(
    (customer: ICustomerProperties) => {
      navigate(`${customer.id}`);
      setProp("customerDetail", cloneDeep(customer));
    },
    [navigate, setProp]
  );

  return (
    <XTablePagination
      paginationProps={{
        count: pagination.totalPages,
        page: pagination.pageIndex + 1,
        onChange: onPageChanged,
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell>STT</TableCell>
          <TableCell>Mã khách</TableCell>
          <TableCell>Loại khách </TableCell>
          <TableCell>Tên khách hàng</TableCell>
          <TableCell>Mã số thuế</TableCell>
          <TableCell>Địa chỉ trụ sở</TableCell>
          <TableCell>Tên giao dịch</TableCell>
          <TableCell>Địa chỉ giao hàng </TableCell>
          <TableCell>Ghi chú</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {customers.map((x, i) => (
          <TableRow data-id={x.id} key={x.id} hover>
            <TableCell>{x.orderNumber}</TableCell>
            <TableCell
              sx={{
                minWidth: "100px",
              }}
            >
              {x.code}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "150px",
              }}
            >
              {x.customerType?.name || ""}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "200px",
              }}
            >
              {x.name}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "100px",
              }}
            >
              {x.taxCode}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "200px",
              }}
            >
              {x.headOfficeAddress}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "150px",
              }}
            >
              {x.dealingName}
            </TableCell>
            <TableCell
              sx={{
                minWidth: "200px",
              }}
            >
              {x.deliveryAddresses?.[0]?.address || ""}
            </TableCell>

            <TableCell
              sx={{
                minWidth: "200px",
              }}
            >
              {x.note}
            </TableCell>
            <TableCell width={"20px"}>
              <DetailIconButton
                onClick={() => goDetailHandler(x)}
              ></DetailIconButton>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </XTablePagination>
  );
});
